import PropTypes from 'prop-types'

const UniqueViewsIcon = ({ title }: any) => (
  <svg width={36} height={27} viewBox="0 0 36 27">
    <title>{title}</title>
    <g transform="translate(2 2.483)" strokeWidth={4} fill="none" fillRule="evenodd" strokeLinecap="square">
      <path d="M.636 11.915a1.578 1.578 0 01-.005-1.789C2.4 7.56 8.07.356 16 .356c7.86 0 13.568 7.192 15.36 9.765.375.542.373 1.26-.004 1.8C29.55 14.49 23.798 21.688 16 21.688c-7.87 0-13.582-7.21-15.364-9.774z" />
      <circle cx={15.5} cy={10.9} r={5.9} />
    </g>
  </svg>
)

UniqueViewsIcon.displayName = 'UniqueViewsIcon'

UniqueViewsIcon.propTypes = {
  title: PropTypes.string
}

UniqueViewsIcon.defaultProps = {
  title: 'UniqueViews'
}

export default UniqueViewsIcon
